/**
 * 能力描述：腾讯视频打开webview页面时，链接参数带hidetitlebar=1时会隐藏默认导航栏从而业务自行dom实现，不带的话就是默认导航栏
 需求背景：发现ios视频的一个半屏无导航栏打开活动的场景，进行链接跳转新开webview后没有带hidetitlebar=1参数但也缺失了导航栏
 客户端开发回复ios的openurl会以当前webview形式是否有导航栏为准，来打开下一个页面，这种情况建议openView方法打开
 */
import { isIos, isTenvideo } from '../../env';

const VIDEO_WEBVIEW_SCHEME = 'txvideo://v.qq.com/Html5Activity?url=';

export const iosVideoPlugin = (link: string) => {
  if (/^(http:\/\/)|(https:\/\/)(.*)$/.test(link) && isIos() && isTenvideo()) {
    return `${VIDEO_WEBVIEW_SCHEME}${encodeURIComponent(link)}`;
  }
  return link;
};
